import React from 'react';

// Styles & Assets
import styles from './PatientsPage.module.css';

// Context
import GeneralContext from '../../context/GeneralContext';
import PatientsContext from '../../context/PatientsContext';

// Hooks
import { useState, useContext } from 'react';

// Components
import TablePatients from '../../components/PatientsPage/TablePatients/TablePatients';
import PatientsToolbar from '../../components/PatientsPage/PatientsToolbar/PatientsToolbar';
import SonarPatients from '../../components/PatientsPage/SonarPatients/SonarPatients';
import PatientGeneralInfo from '../../components/PatientsPage/PatientGeneralInfo/PatientGeneralInfo';
import ChatPanel from '../../components/Patient/ChatPanel/ChatPanel';

// PatientsPage: Handles whether to render the regular or the SONAR view and in the
// regular view whether the patientsTable or the general view should be rendered
const PatientsPage: React.FC = () => {

    const generalContext = useContext(GeneralContext);
    const patientsContext = useContext(PatientsContext);

    const [patientIDToShow, setPatientIDToShow] = useState<number | null>(null); // s'utilitza de key perque es remonti el component a cada canvi

    const patient = patientsContext.patients.find(patient => patient.id === patientIDToShow);

    const handlePatientClick = (id: number) => {
        if (patientIDToShow === id) setPatientIDToShow(null);
        else setPatientIDToShow(id);
    };

    return (
        <div className='pageContainer'>
            <div className={styles.pageContent}>
                {/* Toolbar at the top - part of the content */}
                <PatientsToolbar />
                
                {/* Content area with two columns below toolbar */}
                <div className={styles.contentArea}>
                    {/* Left column - 70% */}
                    <div className={styles.leftColumn}>
                        <div className={styles.tableWrapper}>
                            <div className={styles.tableContainer}>
                                {generalContext.viewSonar ?
                                    <SonarPatients handlePatientClick={handlePatientClick} activePatientID={patientIDToShow} />
                                    :
                                    <TablePatients handlePatientClick={handlePatientClick} activePatientID={patientIDToShow} />
                                }
                            </div>
                        </div>
                        
                        {/* Patient info below the table in left column */}
                        <PatientGeneralInfo
                            key={patientIDToShow}
                            id={patientIDToShow}
                        />
                    </div>
                    
                    {/* Right column - 30% for chat */}
                    {generalContext.isChatOpen && (
                        <div className={styles.chatWrapper}>
                            <ChatPanel handleClickClose={() => generalContext?.setIsChatOpen?.(false)} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PatientsPage;